import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { FacilityService } from "../../../shared/services/facility.service";
import { DepotPQStatusService } from "../report-services/depot-pq-status.service";
import { MTACardTypeService } from "../report-services/mta-card-type.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";

@Component({
	templateUrl: "./district-one-card-express-queue.component.html",
})
export class DistrictOneCardExpressQueueComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private mtacardtypeService: MTACardTypeService,
		private depotpqstatusService: DepotPQStatusService,
		private schoolService: SchoolService,
		private onecardfacilityextendedService: FacilityService,
		private dialogService: DialogService
	) {}

	report = {
		//Insert Custom Parameters Here
		OneCardFacilityID: 0,
		SchoolID: 0,
		DepotPQStatusID: 0,
		GroupByID: "Facility",
		NewPageByGroupID: "Yes",
		ImageLogo: "",
		MTACardTypeID: 0,
	};

	//Insert Custom Lists Here
	OneCardFacilityExtendedList: any = [];
	SchoolList: any = [];
	DepotPQStatusList: any = [];
	ImageLogoList: any = [];
	MTACardTypeList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	GroupByList = [
		//Insert Custom List Items Here
		{
			GroupByName: "Facility",
		},
		{
			GroupByName: "School",
		},
	];

	NewPageByGroupList = [
		//Insert Custom List Items Here
		{
			NewPageByGroupName: "Yes",
		},
		{
			NewPageByGroupName: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 419;
	subscription: any;

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.loadOneCardFacilityExtendedList();
		// this.loadSchoolList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.report.SchoolID = school.SchoolID;
			this.loadDepotPQStatusList();
			this.loadMTACardTypeList();
			this.loadLogolist();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadOneCardFacilityExtendedList() {
		this.report.OneCardFacilityID = 0;
		var result = this.onecardfacilityextendedService.loadFacilityList("");
		result.subscribe(
			(response) => {
				this.OneCardFacilityExtendedList = response;

				this.OneCardFacilityExtendedList.unshift({
					FacilityID: 0,
					FacilityName: "All Facilities",
				});

				this.report.OneCardFacilityID = this.OneCardFacilityExtendedList[0].FacilityID;
			},
			(error) => {}
		);
	}

	private loadSchoolList() {
		this.report.SchoolID = 0;
		var result = this.schoolService.GetSchoolsForUserReport(419);
		result.subscribe(
			(response) => {
				this.SchoolList = response;

				if (this.SchoolList.length > 1) {
					this.SchoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.report.SchoolID = this.SchoolList[0].SchoolID;
				}
			},
			(error) => {}
		);
	}

	private loadDepotPQStatusList() {
		this.report.DepotPQStatusID = 0;
		var result = this.depotpqstatusService.loadDepotPQStatusList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.DepotPQStatusList = response;

				this.report.DepotPQStatusID = this.DepotPQStatusList[0].DepotPQStatusID;
			},
			(error) => {}
		);
	}

	private loadMTACardTypeList() {
		this.report.MTACardTypeID = 0;
		var result = this.mtacardtypeService.loadMTACardTypeList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.MTACardTypeList = response;

				this.report.MTACardTypeID = this.MTACardTypeList[0].MTACardTypeID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.OneCardFacilityIDExtended) {
		//   this.errorMessage = "Select the OneCardFacilityExtended"
		//   return;
		// }

		// if (!this.report.SchoolID) {
		//   this.errorMessage = "Select the School"
		//   return;
		// }

		if (!this.report.DepotPQStatusID) {
			this.errorMessage = "Select the Depot PQ Status";
			return;
		}

		if (!this.report.GroupByID) {
			this.errorMessage = "Select the Group By";
			return;
		}

		if (!this.report.NewPageByGroupID) {
			this.errorMessage = "Select the New Page By Group";
			return;
		}

		// if (!this.report.MTACardTypeID) {
		//   this.errorMessage = "Select the MTA Card Type"
		//   return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 419;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: OneCardFacilityIDExtended
		strParam += this.report.OneCardFacilityID + "|OneCardFacilityIDExtended";

		//Parameter 2: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 3: IDDepotPQStatusID
		strParam += "," + this.report.DepotPQStatusID + "|IDDepotPQStatusID";

		//Parameter 4: GroupBy
		strParam += "," + this.report.GroupByID + "|GroupBy";

		//Parameter 5: NewPageByGroup
		strParam += "," + this.report.NewPageByGroupID + "|NewPageByGroup";

		//Parameter 6: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		//Parameter 7: MTACardTypeID
		strParam += "," + this.report.MTACardTypeID + "|MTACardTypeID";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
